import { render } from "./headerOffre.vue?vue&type=template&id=189f9b75"
import script from "./headerOffre.vue?vue&type=script&lang=ts"
export * from "./headerOffre.vue?vue&type=script&lang=ts"
script.render = render

export default script